import { YesNoQuestion } from '@/gql/graphql';

import { FormField, FormItem } from '@/components/ui/form/form.component';
import { QuestionRadio } from './components/question-radio/question-radio.question-input';
import { QuestionText } from './components/question-text/question-text.question-input';
import { QuestionTitle } from './components/question-title/question-title.question-input';

type Props = {
  index: number;
  formControl: any;
  disabled?: boolean;
  question: YesNoQuestion;
  handleQuestionAnswer: (question: YesNoQuestion, answer: string) => void;
};

export const QuestionInput = ({ index, disabled, question, formControl, handleQuestionAnswer }: Props) => {
  const onQuestionAnswer = (question: YesNoQuestion, value: string) => {
    handleQuestionAnswer(question, value);
  };
  return (
    <div data-testid={`question-${question.id}-input`} className="bg-white p-3 rounded flex flex-col gap-y-4">
      <FormField
        control={formControl}
        name={question.id}
        render={({ field }) => {
          return (
            <FormItem className="gap-y-4 items-start">
              <QuestionTitle index={index} question={question} />
              <QuestionText question={question} />
              <QuestionRadio
                field={field}
                disabled={disabled}
                question={question}
                handleQuestionAnswer={onQuestionAnswer}
              />
            </FormItem>
          );
        }}
      />
    </div>
  );
};
